var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 92,
    viewBox: "0 0 104 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0127 29.75C39.0127 32.3359 37.9855 34.8158 36.157 36.6443C34.3285 38.4728 31.8486 39.5 29.2627 39.5C26.6768 39.5 24.1969 38.4728 22.3684 36.6443C20.5399 34.8158 19.5127 32.3359 19.5127 29.75C19.5127 27.1641 20.5399 24.6842 22.3684 22.8557C24.1969 21.0272 26.6768 20 29.2627 20C31.8486 20 34.3285 21.0272 36.157 22.8557C37.9855 24.6842 39.0127 27.1641 39.0127 29.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0127 0.5C9.56488 0.5 6.25828 1.86964 3.82031 4.30761C1.38233 6.74558 0.0126953 10.0522 0.0126953 13.5V78.5C0.0126953 81.9478 1.38233 85.2544 3.82031 87.6924C6.25828 90.1304 9.56488 91.5 13.0127 91.5H91.0127C94.4605 91.5 97.7671 90.1304 100.205 87.6924C102.643 85.2544 104.013 81.9478 104.013 78.5V13.5C104.013 10.0522 102.643 6.74558 100.205 4.30761C97.7671 1.86964 94.4605 0.5 91.0127 0.5H13.0127ZM91.0127 7C92.7366 7 94.3899 7.68482 95.6089 8.90381C96.8279 10.1228 97.5127 11.7761 97.5127 13.5V55.75L72.9622 43.0945C72.3526 42.7892 71.6625 42.6832 70.9894 42.7917C70.3164 42.9002 69.6944 43.2176 69.2117 43.699L45.0967 67.814L27.8067 56.296C27.1824 55.8804 26.4336 55.6935 25.6873 55.7669C24.9409 55.8404 24.243 56.1697 23.7117 56.699L6.5127 72V13.5C6.5127 11.7761 7.19752 10.1228 8.4165 8.90381C9.63549 7.68482 11.2888 7 13.0127 7H91.0127Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.db2c134c4f9f55b9503d26ee395adad0.svg";
export { ForwardRef as ReactComponent };